import React from 'react';
import Arrow from 'components/Icons/CaretIcon';
import IconButton from 'components/Button/IconButton';
import ImageWithFallback from 'components/ImageWithFallback/ImageWithFallback';
import Modal, { ModalRef } from 'components/Modal/Modal';
import styles from './ExpandedCameraImageModal.module.css';

type ExpandedCameraImageModalProps = {
    modalRef: React.RefObject<ModalRef | null | undefined>;
    imageSrc: string | null;
    fallbackSrc?: string | null;
    onClose: () => void;
    fallback?: React.ReactNode;
    onPrev?: (() => void) | null;
    onNext?: (() => void) | null;
};

function ExpandedCameraImageModal({
    modalRef,
    imageSrc,
    fallbackSrc,
    onClose,
    fallback = null,
    onPrev = null,
    onNext = null,
}: ExpandedCameraImageModalProps): JSX.Element {
    return (
        <Modal ref={modalRef} onClose={onClose} type="fullSizeImage">
            <div className={styles.container}>
                {imageSrc ? (
                    <ImageWithFallback
                        src={imageSrc}
                        fallbackSrc={fallbackSrc || imageSrc}
                        alt=""
                        className={styles.fullImg}
                        data-testid="expandable-image"
                    />
                ) : (
                    fallback
                )}
                {onPrev ? (
                    <IconButton
                        className={`${styles.navButton} ${styles.navLeft}`}
                        onClick={onPrev}
                        data-testid="expanded-image-prev"
                    >
                        <Arrow direction="left" color="#ffffff" className={styles.navIcon} />
                    </IconButton>
                ) : null}
                {onNext ? (
                    <IconButton
                        className={`${styles.navButton} ${styles.navRight}`}
                        onClick={onNext}
                        data-testid="expanded-image-next"
                    >
                        <Arrow direction="right" color="#ffffff" className={styles.navIcon} />
                    </IconButton>
                ) : null}
            </div>
        </Modal>
    );
}

export default ExpandedCameraImageModal;
